import { render, staticRenderFns } from "./updataPassword.vue?vue&type=template&id=3283decb&scoped=true&"
import script from "./updataPassword.vue?vue&type=script&lang=js&"
export * from "./updataPassword.vue?vue&type=script&lang=js&"
import style0 from "./updataPassword.vue?vue&type=style&index=0&id=3283decb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3283decb",
  null
  
)

export default component.exports